import { Routes } from '@angular/router';
import { authActionRouteClient } from './pages/auth-action/auth-action.route';
import { bankLinkedRouteClient } from './pages/bank-linked/bank-linked.route';
import { paymentReturnRouteClient } from './pages/payment-return/payment-return.route';
import { shellRouteClient } from './shell/shell.route';

export const routes: Routes = [
  authActionRouteClient,
  bankLinkedRouteClient,
  paymentReturnRouteClient,
  shellRouteClient,
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
];
